<template>
  <div class="cashPackContainer">
    <div class="dashboard">
      <div class="validAmount">
        <div class="amountTitle">待提现金额(元)</div>
        <div class="amount">
          {{ cashData.toBeWithdrawnAmount / 100 || 0 }}
        </div>
      </div>
      <div class="layoutWrapper">
        <div class="completeAmount">
          <div class="amountTitle">已提现(元)</div>
          <div class="amount">
            {{ cashData.withdrawnAmount / 100 || 0 }}
          </div>
        </div>
        <div class="pendingAmount">
          <div class="amountTitle">提现中(元)</div>
          <div class="amount">
            {{ cashData.withdrawingAmount / 100 || 0 }}
          </div>
        </div>
      </div>
      <div class="btn" @click="handleClickWithdraw">提现</div>
      <div class="badge" v-if="withdrawLimit">
        满{{ withdrawLimit / 100 }}元可提现
      </div>
      <div class="pushWhere">
        申请提现后，将在7个工作日内提现至您的{{ cashType }}
      </div>
    </div>
    <div class="detail" v-if="mergedRecords.length">
      <div class="title">红包明细</div>
      <div class="recordList">
        <div class="record" v-for="record in mergedRecords" :key="record.id">
          <div>
            <div class="name" :class="transWithdrawStatus(record)">
              {{ record.comment }}
            </div>
            <div class="time">{{ record.occurTime | formatTime }}</div>
          </div>
          <div>
            <span class="amount" :class="{ fail: record.fail }"
              >{{ record.sign }}{{ record.amount | centToYuan }}</span
            >
            <span class="unit" :class="{ fail: record.fail }">元</span>
          </div>
        </div>
        <div class="noMore">没有更多了~</div>
      </div>
    </div>
  </div>
</template>

<script>
import { centToYuan } from '../../utils';
import {
  throttle,
  formatTime,
  isWeixinBrowser,
  isXlMiniProgram,
  getUrlParam,
  toXlWxaWeb
} from '@/utils';
import { postTakeCash } from '../../api';
import { wxAuth, getHllTicket } from '../../libs/wx';
import { mapState } from 'vuex';
import { isXlUserApp } from '@/utils/judgeEnv';
import { isXL } from '../../utils';

const withdrawStatusMap = {
  // 1未达提现门槛；2账号异常提现失败；3提现中；4提现失败；5提现成功
  1: 'fail',
  2: 'fail',
  3: 'pending',
  4: 'fail',
  5: 'success'
};
export default {
  filters: {
    centToYuan: val => {
      return centToYuan(val, 2);
    },
    formatTime: v => {
      return v
        ? formatTime(
            'yyyy.MM.dd hh:mm:ss',
            new Date(typeof v === 'string' ? v.replace(/-/g, '/') : v)
          )
        : '';
    }
  },
  props: ['cashData', 'cashType'],
  data() {
    return {
      cashPackData: {}
    };
  },
  created() {
    if (isWeixinBrowser() && this.isWithdrawToWX) {
      wxAuth();
    }
  },
  computed: {
    ...mapState('app', {
      takeCashType: state => state.actData.takeCashType,
      taskCashLimit: state => state.actData.taskCashLimit,
      cashStartTime: state => state.actData.cashStartTime,
      cashEndTime: state => state.actData.cashEndTime,
      currentTime: state => state.actData.currentTime
    }),
    mergedRecords() {
      const userRewardDetails = (
        (this.cashData && this.cashData.userRewardDetails) ||
        []
      ).map(record => {
        return {
          ...record,
          sign: '+'
        };
      });
      const withdrawRecord = (
        (this.cashData && this.cashData.withdrawRecord) ||
        []
      ).map(record => {
        const isWithdrawFailed = withdrawStatusMap[record.status] === 'fail';
        return {
          ...record,
          sign: isWithdrawFailed ? '' : '-',
          fail: isWithdrawFailed,
          comment: record.statusStr
        };
      });
      userRewardDetails.push(...withdrawRecord);
      return userRewardDetails.sort(
        (recordA, recordB) => recordB.occurTime - recordA.occurTime
      );
    },
    isWithdrawToWX() {
      // 0 提现到微信零钱 1提现到用户钱包
      return this.takeCashType === 0;
    },
    withdrawLimit() {
      return this.taskCashLimit;
    }
  },
  methods: {
    handleClickWithdraw: throttle(function() {
      if (this.isNotInWithdrawTime()) {
        this.$hll.toast('不在提现时间内');
        return;
      }
      if (this.cashData.toBeWithdrawnAmount === 0) {
        this.$hll.toast('没有待提现金额');
        return;
      }
      if (
        this.withdrawLimit &&
        this.cashData.toBeWithdrawnAmount <= this.withdrawLimit
      ) {
        this.$hll.toast(`满${this.withdrawLimit / 100}元才可提现哦`);
        return;
      }
      if (this.isWithdrawToWX) {
        if (isWeixinBrowser()) {
          const hllTicket = getHllTicket();
          if (!hllTicket) {
            return wxAuth();
          }
          this.takeCashHandle({ hllTicket, channel: 0 });
          return;
        }
        if (isXlMiniProgram()) {
          const openId = getUrlParam('open_id');
          this.takeCashHandle({ openId, channel: 1 });
          return;
        }
        if (isXlUserApp()) {
          const token = getUrlParam('token');
          if (!token) {
            throw new Error('没有token');
          }
          return toXlWxaWeb(token);
        }
        return this.$hll.toast('请在微信中进入活动提现');
      }
      // if (isXlDriverApp()) {
      //   return this.$hll.toast('请在微信中进入活动提现');
      // }
      this.takeCashHandle({ type: this.takeCashType });
    }, 1000),
    transWithdrawStatus(record) {
      return withdrawStatusMap[String(record.status)] || '';
    },
    takeCashHandle(data) {
      let cashType = this.takeCashType ? { type: this.takeCashType } : {};
      let params = data ? { ...data, ...cashType } : data;
      this.$hll.showLoading({ disableLogo: isXL() });
      postTakeCash(params).then(res => {
        console.log(res, 'res++++++');
        this.$hll.hideLoading(0);
        this.$emit('success');
      });
    },
    isNotInWithdrawTime() {
      const now = this.currentTime;
      return now > this.cashEndTime || now < this.cashStartTime;
    }
  }
};
</script>

<style lang="less" scoped>
.cashPackContainer {
  box-sizing: border-box;
  width: 100%;
  padding: 40px 24px 24px 24px;

  .amount {
    font-family: 'Alibaba Zhixing';
  }
}
.dashboard {
  position: relative;
  height: 640px;
  box-sizing: border-box;
  text-align: center;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
  padding-top: 50px;

  .amountTitle {
    font-size: 30px;
    color: #8c8c8c;
  }

  .validAmount {
    font-size: 68px;
    color: #ff6600;
  }

  .layoutWrapper {
    margin: 56px 80px;
    display: flex;
    justify-content: space-between;

    .amount {
      font-size: 44px;
      color: #262626;
    }
  }

  .btn {
    margin: 0 auto;
    width: 560px;
    height: 88px;
    background: linear-gradient(to top, #ff7e00 0%, #ff9600 39%, #ffb80f 99%);
    border-radius: 44px;
    font-size: 40px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: normal;
  }

  .badge {
    position: absolute;
    top: 0;
    right: 0;
    padding: 6px 25px;
    background: #ffe9de;
    border-radius: 23px 0 0 23px;
    font-size: 26px;
    color: #ff6600;
  }
  .pushWhere {
    width: 560px;
    font-size: 26px;
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    font-weight: 400;
    text-align: center;
    color: #ff6600;
    margin: 25px auto;
  }
}
.detail {
  margin-top: 40px;
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);

  .title {
    text-align: center;
    font-size: 36px;
    color: #262626;
    padding: 40px 0 24px;
  }

  .recordList {
    width: 100%;
    box-sizing: border-box;
    padding: 0 30px 10px;

    .record {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px solid #e8e8e8;

      .name {
        font-size: 30px;
        color: #262626;

        &.success {
          color: #2dad69;
        }

        &.pending {
          color: #ffa600;
        }

        &.fail {
          color: #8c8c8c;
        }
      }

      .unit {
        font-size: 30px;
        color: #262626;

        &.fail {
          color: #8c8c8c;
        }
      }

      .time {
        font-size: 28px;
        color: #8c8c8c;
      }

      .amount {
        font-size: 42px;
        color: #262626;
        font-family: 'Alibaba Zhixing';

        &.fail {
          color: #8c8c8c;
        }
      }
    }

    .noMore {
      margin: 30px 0;
      text-align: center;
    }
  }
}
</style>
